<script>
  export let title;
</script>

<h1 class="post-title">{title}</h1>

<style>
  .post-title {
    font-size: 32px;
    font-weight: 400;
    margin: 48px 0;
  }

  @media only screen and (min-width: 600px) {
    .post-title {
      font-size: 48px;
    }
  }
</style>
